import React from 'react';
import { change, Field, getFormValues } from 'redux-form';
import { RenderToggleSwitch } from 'src/components/views/common/forms/render-toggle-switch';
import { withI18n } from '@shopify/react-i18n';
import { RenderRangeSlider } from 'src/components/views/common/forms/render-range-slider';
import { connect } from 'react-redux';
import _ from 'lodash';
import { allowUsingNewSearchSettings } from 'src/helpers/search-settings-helper';

const SemanticSettings = props => {
  const { i18n, semanticSetting, formValues, isNewSearch } = props;
  const { available } = semanticSetting;
  const { enable } = formValues;

  return (
    <>
      <div className="enable-semantic-search">
        <Field
          name={`enable`}
          disabled={!isNewSearch}
          component={RenderToggleSwitch}
          label={i18n.translate('AdminHTML.SemanticSearch.Setting.enable')}
        />
      </div>
      {available && enable && isNewSearch && (
        <div className="semantic-setting">
          <div className="content">
            <span className="title">
              {i18n.translate('AdminHTML.SemanticSearch.Setting.title')}
            </span>
            <span className="description">
              {i18n.translate('AdminHTML.SemanticSearch.Setting.weightContent')}
            </span>
          </div>
          <div className="setting-weight">
            <Field
              name={`weight`}
              component={RenderRangeSlider}
              beforeOutput={i18n.translate('AdminHTML.SemanticSearch.Setting.beforeSliderOutput')}
              afterOutput={i18n.translate('AdminHTML.SemanticSearch.Setting.afterSliderOutput')}
              parentClass={'.BC-Page .BC-Page__Semantic .semantic-setting'}
              parse={value => value * 0.01}
              format={value => value * 100}
              step={25}
              min={25}
            />
          </div>
        </div>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateField: (field, value) => dispatch(change(`SemanticSearchForm`, field, value))
});
const mapStateToProps = state => {
  const semanticSetting = _.get(state.semantic, 'settings', {
    enable: false,
    weight: 0.5
  });
  const formValues = getFormValues('SemanticSearchForm')(state);
  const searchVersion = _.get(state.oauth, 'tenantApp.parseParams.searchVersion', '1.0');
  const isNewSearch = allowUsingNewSearchSettings(searchVersion);
  return {
    semanticSetting,
    formValues,
    isNewSearch
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(SemanticSettings));
